import { Router, Params, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnChanges, HostListener, DoCheck } from '@angular/core';
import { Logger } from 'angular2-logger/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DashboardService } from '../../dashboard.service';
import { SharedService } from '../../../shared/shared.service';
import { SocketioService } from '../../socketio.service';
import { PusherService } from '../../../shared/pusher.service';
import { interval } from "rxjs/observable/interval";
import { startWith, switchMap } from "rxjs/operators";
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';
import { PushNotificationOptions, PushNotificationService } from 'ngx-push-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { FormGroup, Validators, FormBuilder} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { UserService } from '../../../admin/user/user.service';


declare var $: any;
@Component({ 
    selector: 'app-list',
    templateUrl: './list.component.html', 
    styleUrls: ['./list.component.scss'],
    providers: [PusherService, DatePipe, UserService]
})

export class ListComponent implements OnInit, OnChanges, DoCheck {
    public list_type: string;
    public room_list: any;
    public inactivity_message:any =[];
    public rooms_id: any = [];
    public show_search: boolean;
    public new_room_id: any;
    public read_msg: any;
    public active_control: boolean;
    public tipOrden : any;
    public orden : any;
    public countReceived : any;
    public countArchived : any;
    public countEspera : any;
    public time_zone : string;
    public activeTab: string = 'activos'; 
    public activosList : any =[];
    public inactivosList : any = [];


    public dropdownList2 = [];
    public dataReturn: any;
    public variable_nueva:any ;
    public id_category: any;

    public active_agents: any;

    public nameAgent : any;
    
    public filter: FormGroup; 
    public letData : any;
    // Variables para el modal.
    public title_toModal: string;
    public body_toModal: string;

    public selectedRoomID : any;
    public banderaList : any;
    public plataformaRoom : any;

    private messageSubs: Subscription;
    public intervalSub: Subscription;
    public intervalSubBySession: Subscription;

    // Variable que reemplaza a data.data.data
    private dataRemovedFromArray: any = [];
    //Variables para la detección de cierre de sesión o todo lo relacionado a cambio de chat.
    private flagStatus: any;
    private flag_for_chat_transmitter: any;
    private room_id: any;
    private flag_for_chat_receiver: any;

    private filterDesde:string;
    private filterHasta:string;

    private bClearDate : any; 

    public arrayCheck = [];
    public arrayCheckSel = [];
    public selectAll : any;
    public user_id: any;

    public load : any;

    public role_id: any;
    
    public myDate : any = new Date();
    public horaLocal : any;
    public fechaActual: any;
    public matriz_final:any ;
    
    constructor(
        private activatedRoute: ActivatedRoute,
        public _router: Router,
        private _dashboardService: DashboardService,
        private _sharedService: SharedService,
        public _socketioService: SocketioService,
        private logger: Logger,
        private toastr: ToastsManager,
        private pusherService: PusherService, 
        private spinner: NgxSpinnerService,
        private fb: FormBuilder,
        private _pushNotificationService: PushNotificationService,
        private userService : UserService,
        private datePipe: DatePipe
        
    ) {

        // subscribe to router event 
        this.activatedRoute.params.subscribe(params => {
            this.list_type = params['type'];
            this._sharedService.routeTabArchived(this.list_type);
        });
        this.read_msg = false;
        this.filter = this.fb.group({
            textoFiltro: ['', Validators.required],
            fechaDesde : ['', Validators.required],
            fechaHasta : ['', Validators.required],
            checkVariable : ['', Validators.required]
        });

        let data = { 
            auth_token: this._sharedService.getCookie("auth_token"),
            
        };
    
        this._sharedService.getCurrent(data).subscribe(
            data => {
            if (data.status) { 
                this.role_id = data.data.role_id;
                this.user_id = data.data.id;
                this.time_zone = data.data.time_zone;
            } else {
                this.logger.log(data.message);
            }
            },
            error => {
            this.logger.log(error);
    
            }
        
        );

        this.fechaActual = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
        

    }

    message:string;

    receiveMessage($event) {
        if('actualizar' == $event) {
            this.selectedRoomID = '';
            let data = this.getDataCookie();
            this.getInitialData(data);
        }
        this.message = $event
    }

    changeRoomID(roomidselected, plataforma) {
        this.load = '0';
        this.selectedRoomID = roomidselected;
        this.banderaList = true;
        this.plataformaRoom = plataforma;
    }


    ngDoCheck(){
        if (this.banderaList == false) {
            this.banderaList = true;

            let vUser = '';
            if (this._sharedService.activateBlockSupervisor().agent_id) {
                vUser = this._sharedService.activateBlockSupervisor().agent_id;
            } else {
                vUser =  this._sharedService.user.id;
            }

            let data = {
                user:vUser,
                role_id:this.role_id,
                auth_token: this._sharedService.getCookie('auth_token')
            };

            this._dashboardService.roomsPending(data).subscribe(
                data => {
                    this.banderaList = true;

                    let data2 = this.getDataCookie();
                    this.letData = data2;
                    this.getInitialData(data2);
                },
                error => {
                    this.logger.log(error);
                }
            );

           
        }
    }

    ngOnChanges() {
        this.myDate = new Date();
    }

    ngOnInit() {
        this.load = '1';
        this.bClearDate = false;
        this.filter.value.fechaDesde = this.fechaActual;
        this.filter.value.fechaHasta = this.fechaActual;
        this.filterDesde = this.fechaActual;
        this.filterHasta = this.fechaActual;
        this._pushNotificationService.requestPermission();

        let data2 = {
            auth_token: this._sharedService.getCookie("auth_token")
        };
        this._sharedService.getCategorias(data2).subscribe((returndata)=>{
            this.dataReturn = returndata.message;
            this.matriz_final = this.dataReturn.categorias;

            for(let i = 0; i < this.dataReturn.categorias.length ; i++){
                this.matriz_final[i].valores =  [];
                this.id_category = this.dataReturn.categorias[i].id;
                this.variable_nueva = this.dataReturn.descripciones.filter(description => description.id == this.id_category);
                this.matriz_final[i].valores = this.variable_nueva;
            }
        });

        let data = this.getDataCookie();
        this.active_control = this._sharedService.activateBlockSupervisor().isAdmin;
        this.nameAgent = this._sharedService.activateBlockSupervisor().name_agent;
        this.letData = data;
        this.getInitialData(data);
        this._requestMessage();

        this.messageSubs = this.pusherService.messages.subscribe(
            msg => {
                this.pushMessage(msg);
            },
            error => {
                this.logger.log(error);
            }
        );
        this._poolinRequestData(); 
    }

    paginarRooms(valor) {
        this.selectedRoomID = ""; // Esto ocultará el componente app-room
        if(valor == '1'){
            this.list_type = 'received';
        } else if(valor == '2') {
            this.list_type = 'archived';
        }  else {
            this.list_type = 'pending';
        }

        let data = this.getDataCookie();
        this.letData = data;
        this.getInitialData(data);
    }

    irRoom() {
        this.load = '0';

    }

    private pushMessage(msg: any) { 
        
        if (msg.type === 'message') {
            

            if (msg.room.user_id === this._sharedService.user.id) {

                this.new_room_id = msg.message.room_id;
                let message = this._socketioService.rooms[msg.message.room_id].msgs;

                    if(message !== undefined) { 
                        message.push(msg.message);
                        this.notificationMsg("#" + msg.room.id +" "+ msg.room.title, msg.message.content); // notifica cada mensaje que llega
                        }

                console.log('aqui 1---');
                this._socketioService.getRoomMsgs(msg.message.room_id);
                
                let index = this.room_list.findIndex(x => x.id === msg.message.room_id);
                if (index === -1) {
                    let list = this.room_list.push(msg.room);
                }
                console.log('variable msg ',msg);
                console.log('variable room_list',this.room_list);

                index = this.room_list.findIndex(x => x.id === msg.message.room_id);

                this.room_list[index].latest_message.viewconversation = 'view_conversation';
                this.room_list[index].latest_message.content = msg.message.content;
                this.room_list[index].latest_message.class = 'green_msg';
                this.room_list[index].latest_message.timeMsg = 'hace ' + msg.diffTime + ' min';

                console.log('tiempo espera--> hace ' + msg.diffTime + ' min' );
            }

        } else {
            
            this.new_room_id = msg.room.id; 

            if (!this._socketioService.rooms[msg.room.id]) {
                let info = {
                    
                    created_at: msg.room.created_at,
                    //created_at: this._sharedService.convertirZonaHoraria(),
                    gender: "perfil_hombre",
                    id: msg.room.id,
                    image: null,
                    latest_message: msg.latest_message,
                    room_status_id: msg.room.room_status_id,
                    room_type_id: msg.room.room_type_id,
                    session_id: msg.room.session_id,
                    start_chat: 0,
                    title: "Conversación",
                    updated_at: msg.room.updated_at,
                    user_id: msg.room.user_id, 
                }; 
                    this._socketioService.rooms[msg.room.id] = {};
                    this._socketioService.rooms[msg.room.id].info = info;
                    this._socketioService.rooms[msg.room.id].msgs = [];

            }
            this.notificationMsg("#" + msg.room.id +" "+ msg.room.title, msg.message ? msg.message.content: ""); // notifica room
        }

        let data = this.getDataCookie();
        //this.spinner.show();
        this._dashboardService.listRoom(data).subscribe(
            data => {
                this.getDataRooms(data, true);
            },
            error => {
                this.logger.log(error);
          //      this.spinner.hide();
            }
        );

        //this.getInitialData(this.getDataCookie());
    }

    private _poolinRequestData() {
        //poolling request data
        this.intervalSub = interval(15000).pipe(
            startWith(3000),
            switchMap(() => this._dashboardService.listRoom(this.letData))
        ).subscribe(
            data => {
                this.getDataRooms(data, false);
            },
            error => {
                this.logger.log(error);
            });
    }

    private _requestMessage() {
        interval(1000).pipe(startWith(1000)).subscribe(i => {

        this.read_msg = this._socketioService.read_msg;

            if (this.read_msg) {
            this.getInitialData(this.getDataCookie());
            this._socketioService.read_msg = false;
            }

        });
    }


    public handleScroll(event) {
        console.log('scroll occurred', event.originalEvent);
        if (event.isReachingBottom) {
        console.log(`the user is reaching the bottom`);
        }
        if (event.isReachingTop) {
        console.log(`the user is reaching the top`);
        }
        if (event.isWindowEvent) {
        console.log(`This event is fired on Window not on an element.`);
        }
    
        }

    notificationMsg(room, msg) {
        const title = room;
        const options = new PushNotificationOptions();
        options.body = msg;
        options.icon = "../../../../assets/img/notification/icon_notification2.png";

        this._pushNotificationService.create(title, options).subscribe((notif) => {
        if (notif.event.type === 'show') {
            setTimeout(() => {
            notif.notification.close();
            }, 4000);
        }
        },
    (err) => {
    });

    this.playAudio();
}

    playAudio()
    {
        let audio = new Audio();
        let base = audio.baseURI.slice(-1) == "/" ? audio.baseURI : audio.baseURI + "/";
        audio.src = base + "assets/sound/mensaje.mp3";
        audio.load();
        audio.play();
    }

    filtrarRooms() {
        this.load = '1';
        this.selectedRoomID = "";
        if(this.list_type == 'received' && this.filter.value.textoFiltro) {
            let data = this.getDataCookie();
            this.letData = data;
            this.getInitialData(data);
        } else {
            if(this.filter.value.textoFiltro || (this.filter.value.fechaDesde && this.filter.value.fechaHasta) ){
                let data = this.getDataCookie();
                this.letData = data;
                this.getInitialData(data);
            }
        }
        
    }

    limpiarFecha() {
        this.bClearDate = true;
        this.filterHasta = '';
        this.filterDesde = '';
        this.filter.value.fechaDesde = '';
        this.filter.value.fechaHasta = '';
        let data = this.getDataCookie();
        this.letData = data;
        this.getInitialData(data);
        
    }

    changeFiltro() {
        if(!this.filter.value.textoFiltro) {
            let data = this.getDataCookie();
            this.letData = data;
            this.getInitialData(data);
        }
    }

    getInitialData(data) {
        if(this.load == '1') {
            this.spinner.show();
        }

        this._dashboardService.listRoom(data).subscribe(
            data => {
                this.getDataRooms(data, true);
            },
            error => {
                this.logger.log(error);
                if(this.load == '1'){
                    this.spinner.hide();
                }
                
            }
        );
    }

    getDataRooms(data: any, first: boolean) {
        this.dataRemovedFromArray = [];


        this.orden = data.data.ordenar;

        this.countReceived = data.data.countRoomsReceived;

        this.countArchived = data.data.countRoomsArchived;

        this.countEspera = data.data.countRoomsEspera;


        for (let i in data.data.data.data) {

            if (i != 'flagStatus' && i != 'flag_for_chat_transmitter' && i != 'room_id' && i != 'flag_for_chat_receiver' ) {
                this.dataRemovedFromArray.push(data.data.data.data[i]);
            } else if (i == 'flagStatus') {
                // Acá va la bandera de si ese usuario fue deslogueado.
                this.flagStatus = data.data.data.data[i];
            } else if (i == 'flag_for_chat_transmitter') {
                // Acá va el id del usuario al que se le quita la conversación.
                this.flag_for_chat_transmitter = data.data.data.data[i];
            } else if (i == 'room_id') {
                // Acá va el id de la room que cambia de usuario.
                this.room_id = data.data.data.data[i];
                
            } else if (i == 'flag_for_chat_receiver') {
                this.flag_for_chat_receiver = data.data.data.data[i];            }
        }
        if (this.flagStatus == 1) {
            Swal({
                title: "Advertencia",
                text: "Tu sesión ha sido cerrada por un administrador",
                type: 'warning',
                timer: 10000,
                showConfirmButton: false
            }).then(() => {
                this.cancelInterval();
                this.cancelIntervalBySession();
                this.messageSubs.unsubscribe();
                this._router.navigateByUrl("/auth").then(e => {
                    if (e) {

                        this._sharedService.user = null;
                        this._sharedService.setCookie('auth_token', '', -1, environment.c_domain);
                        } else {
                        console.log("Navigation has failed!");
                        }
                });
            });
        }
        
        if (this.flag_for_chat_transmitter == 1 && this.room_id != null && this.room_id != '') {
            Swal({
                title: "Advertencia",
                text: "La conversación "+this.room_id+" ha sido asignada a otro agente." ,
                type: 'warning',
                timer: 10000,
                showConfirmButton: false
            }).then(() => {
                // Acá se actualiza la página.
                //this.reload();
                this._router.navigateByUrl("/").then(e => {
                    if (e) {
                      //console.log("Navigation is successful!");
                      //this._sharedService.user = null;
                      //this._sharedService.setCookie('auth_token', '', -1, environment.c_domain);
                    } else {
                        console.log("Navigation has failed!");
                    }
                });
            });
        }
        

        if (this.flag_for_chat_receiver == 1 && this.room_id != null && this.room_id != '') {
            Swal({
                title: "Advertencia",
                text: "La conversación No. "+this.room_id+" ha sido asignada para ti!" ,
                type: 'warning',
                timer: 10000,
                showConfirmButton: false
            }).then(() => {
                // Acá se actualiza la página.
                //this.reload();
                this._router.navigateByUrl("/").then(e => {
                    if (e) {
                      //console.log("Navigation is successful!");
                      //this._sharedService.user = null;
                      //this._sharedService.setCookie('auth_token', '', -1, environment.c_domain);
                    } else {
                      //console.log("Navigation has failed!");
                    }
                });
            });
        }
        
        data.data.data2 = this.dataRemovedFromArray;

        if (data.status) {
            if (data.data.dataResponse) {
                this.room_list = data.data.dataResponse; // list of rooms.
                this.rooms_id = [];
            
                
                let arr = this.room_list;
                let l = arr.length;
                this.room_list.forEach((element, index) =>{
                    
                    if(element.id === 1) {
                        element = this.processList(element);
                    }

                    element.created_at =this._sharedService.convertirZonaHoraria(element.created_at, this.time_zone,element.time_zone_sistem);

                    this.rooms_id.push(element.id);
                    

                    for (let l = 0; l < arr.length; l++) {
                        element = this.processList(arr[l]);

                        if (first) {
                            
                            if (!this._socketioService.rooms[element.id])
                                this._socketioService.rooms[element.id] = {};
                            this._socketioService.rooms[element.id].info = element;
                        } else {
                            if (element.latest_message !== null) {

                                if (this._socketioService.rooms[element.id] && this._socketioService.rooms[element.id].info.latest_message) {
                                    
                                    if (!this._socketioService.rooms[element.id].info.latest_message.created_at) {
                                        this._socketioService.rooms[element.id].info.latest_message.created_at = [];
                                    }
                                    if (element.latest_message.created_at != this._socketioService.rooms[element.id].info.latest_message.created_at) {
                                        this._socketioService.rooms[element.id].info = element;
                                        this._socketioService.getRoomMsgs(element.id);
                                    }
                                }
                            }
                        }
                    }

                });


                if(this.room_list && this.load == '1') {
                    this.spinner.hide();
                }

                if (this.room_list) {
                    if(this.selectedRoomID) {
                        let rta = this.rooms_id.indexOf(this.selectedRoomID);

                        if (rta < 0) {
                            this.banderaList = false;
                            this.selectedRoomID = '';
                        }
                    }
                }

            } else {
                this.room_list = [];
                this.selectedRoomID = '';
                if (this.load == '1') {
                    this.spinner.hide();
                } 
            }
        } else {
            this.toastr.error(data.message, 'Error');
        }

    }

    roundDown(num){
        var full = num.toString();
        var reg = /([\d]+)/i;
        var res = reg.exec(full);
        return res[1];
    }


    processList(element : any){
        if (this.selectAll == true && this.arrayCheck.indexOf(element.id) === -1) {
            var obj = {
                id: element.id
            };
            this.arrayCheckSel.push(obj);
            this.arrayCheck.push(element.id);
            element.check = true;
        } else {
            if(this.arrayCheck.indexOf(element.id) === -1) {
                element.check = false;
            } else {
                element.check = true;
            }
        }

        element.gender = "perfil_hombre";
        if ((element.title.toUpperCase().indexOf("MARIA") >= 0) ||
            (element.title.toUpperCase().indexOf("MARIA") >= 0) ||
            (element.title.toUpperCase().indexOf("MARIELA") >= 0) ||
            (element.title.toUpperCase().indexOf("GABRIELA") >= 0)) {
            element.gender = "perfil_mujer";
        }
        if (element.latest_message !== null) {
            element.latest_message.class = "red_msg";
            let endDate : any;
            
            if(element.latest_message.updated_at == null) {
                endDate = element.latest_message.created_at;
            } else {
                endDate = element.latest_message.updated_at;
            }

            this.myDate = new Date();

            if(element.time_zone!= element.time_zone_sistem){
            endDate = this._sharedService.convertirZonaHoraria(endDate,this.time_zone,element.time_zone_sistem);
            }
            let ultimoMsj : any = new Date(endDate)

            let purchaseDate : any = new Date(this.myDate);

            let diffMs = (purchaseDate - ultimoMsj); // milliseconds
            let diffDays : any = this.roundDown(diffMs / 86400000); // days
            let diffHrs : any = this.roundDown((diffMs % 86400000) / 3600000); // hours
            let diffMins : any = this.roundDown(((diffMs % 86400000) % 3600000) / 60000); // minutes
            let seconds : any = this.roundDown((((diffMs % 86400000) % 3600000) % 60000) / 1000 );

            if(diffDays > 0) {
                    element.latest_message.timeMsg = 'hace ' + diffDays + ' días';
            }else if(diffHrs > 0){
                    element.latest_message.timeMsg = 'hace ' + diffHrs + ' hrs';
            } else if(diffMins < 60) {
                    element.latest_message.timeMsg = "hace " + diffMins + " min";
                    if (diffMins < 3) {
                        element.latest_message.class = "green_msg";
                    } else if (diffMins < 6) {
                        element.latest_message.class = "lightgreen_msg";
                    } else if (diffMins < 11) {
                        element.latest_message.class = "yellow_msg";
                    }
            }
        }

        return element;
    }

    onSearch(data: string) {
        if (data === 'test') {
            this.show_search = true;
        } else {
            this.show_search = false;
        }
    }

    reload() {
        location.reload();
    }

    testpusher(val) {

        let data2 = {
            auth_token: this._sharedService.getCookie('auth_token'),
            list_type : this.list_type,
            filtro : this.filter.value.textoFiltro,
            fechaDesde : this.filter.value.fechaDesde,
            fechaHasta : this.filter.value.fechaHasta,
        };
        this.getInitialData(data2);

    }

    ngOnDestroy() {
        this.messageSubs.unsubscribe();
        $("body>#controlRoom2").remove();
        
    }

    getDataCookie() : any{
        if(this.list_type != 'received'  && this.bClearDate == false && this.filter.value.fechaDesde == '' && this.filter.value.fechaHasta == '') {
            this.filter.value.fechaDesde = this.fechaActual;
            this.filter.value.fechaHasta = this.fechaActual;
        }
        
        let data = {
            auth_token: this._sharedService.getCookie('auth_token'),
            user_id : this._sharedService.activateBlockSupervisor().agent_id,
            list_type : this.list_type,
            filtro : this.filter.value.textoFiltro,
            fechaDesde : this.filter.value.fechaDesde,
            fechaHasta : this.filter.value.fechaHasta,
            role_id : this.role_id,
            soloVariable : this.filter.value.checkVariable
        };
        return data;
    }

    public cancelInterval() {
        if (this.intervalSub) {
            this.intervalSub.unsubscribe();

            }
    }
    
    public cancelIntervalBySession() {
        if (this.intervalSubBySession) {
            this.intervalSubBySession.unsubscribe();
            }
        }
        
        public changeOrdenar(valor) {
            switch (valor) {
            case 'mayor':
                this.tipOrden = "1";
                break;
            case 'menor':
                this.tipOrden = "2";
                break;
            case 'llegada':
                this.tipOrden = "3";
                break;
            default:
                this.tipOrden = "4";
            }

        let data = {
            ordenar: this.tipOrden,
            user:this._sharedService.user.id
        };

        this._dashboardService.ordenarChats(data).subscribe(
            data => {
            },
            error => {
                this.logger.log(error);
                this.spinner.hide();
            }
        );
    }

    public roomsImportant(valor) {
        let data = {
            room_id: valor
        };

        this._dashboardService.roomsImportant(data).subscribe(
            data => {
                let vData = this.getDataCookie();
                this.getInitialData(vData);
            },
            error => {
                this.logger.log(error);
                this.spinner.hide();
            }
        );
    }

    onChangeCheck(idRooms, isChecked: boolean) {
        this.selectedRoomID = '';
        this.load = '0';
        this.spinner.hide();
        if (isChecked == true) {
            var obj = {
                id: idRooms
            };
            this.arrayCheckSel.push(obj);

            this.arrayCheck.push(idRooms);
        } else {
            this.selectAll = false;
            var indice = this.arrayCheck.indexOf(idRooms);
            this.arrayCheck.splice(indice, 1);

            var indice2 = this.arrayCheckSel.indexOf(idRooms);
            this.arrayCheckSel.splice(indice2, 1);
        }

        return;
    }

    onChangeCheckAll(isChecked: boolean) {
        this.arrayCheckSel = [];
        this.arrayCheck = [];
        
        if (isChecked == true) {
            this.selectAll = true;
        } else {
            this.selectAll = false;
            this.arrayCheckSel = [];
            this.arrayCheck = [];
        }

        let data = this.getDataCookie();
        this.letData = data;
        this.getInitialData(data);
    }

    asignarAgente() {
        if (this.arrayCheckSel.length == 0) {
            this.title_toModal = "Advertencia";
            this.body_toModal = "Debe seleccionar al menos 1 conversación para asignar";
            $('#controlRoom2').modal('toggle',{backdrop: "false"});
            $('#controlRoom2').appendTo("body");
        } else {
            let data;
            this.spinner.show();
            
            let user = '';
            if(this._sharedService.activateBlockSupervisor().agent_id) {
                user = this._sharedService.activateBlockSupervisor().agent_id;
            } else {
                user = this.user_id;
            }
            data = {
                auth_token: this._sharedService.getCookie("auth_token"),
                user_id: user,
                room_id: this.room_id,
                supervisor_id: this.user_id
            }
            
            this.userService.getAgents(data).subscribe(
            data => {
                if (data.data ) {
                    this.activosList = data.data.Activos;
                    this.inactivosList = data.data.Inactivos;
                    this.title_toModal = "Agentes";
                    this.body_toModal = "Si hay usuarios";
                    $('#controlRoomList').modal('toggle',{backdrop: false});
                    $('#controlRoomList').appendTo("body");
                    this.spinner.hide();
                } else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "No hay usuarios disponibles";
                    $('#controlRoom2').modal('toggle',{backdrop: "false"});
                    $('#controlRoom2').appendTo("body");
                    this.spinner.hide();
                }
            }, () => {
                this.title_toModal = "Advertencia";
                this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                $('#controlRoom2').modal('toggle', {backdrop: "false"});
                $('#controlRoom2').appendTo("body");
                this.spinner.hide();
            });
        }
    }

    public newAssignment(data) {  
        data.roomsSelect = this.arrayCheckSel; 
        let token = {
        auth_token: this._sharedService.getCookie("auth_token")
        };
        data.auth_token = token;
        data.user_id_anterior = this.user_id;
        this.userService.getPreviousUser(data).subscribe(
        response => {
            if(this._sharedService.activateBlockSupervisor().agent_id) {
            data.user_id_anterior = response.data;
            } else {
            data.user_id_anterior = this.user_id;
            }
            let userIdPrevious = data.user_id_anterior
            
            
            Swal({
            title: "Perfecto",
            text: 'Las conversaciones seleccionadas serán asignadas al agente ' + data.firstname + ' ' + data.lastname + ' en máximo dos minutos!',
            type: 'success',
            timer: 5000,
            showConfirmButton: false
            }).then(() => {
            this.userService.newAssignmentAll(data).subscribe(data => {
                let dataUpdatePendin = {
                    user:userIdPrevious,
                    role_id:1,
                    auth_token: this._sharedService.getCookie('auth_token')
                };
    
                this._dashboardService.roomsPending(dataUpdatePendin).subscribe(
                );
                this._router.navigateByUrl("/").then(e => {
                if (e) {
                    this.arrayCheckSel = [];
                    let data = this.getDataCookie();
                    this.letData = data;
                    this.getInitialData(data);
                } else {

                }
                });
            }, error => {
                Swal({
                title: "Ups!",
                text: 'Ocurrió un error por favor inténtalo de nuevo.',
                type: 'error',
                timer: 5000,
                showConfirmButton: false
                }); 
            }); // Fin del userService.newAssignment.
            }), error => {
            Swal({
                title: "Ups!",
                text: 'Ocurrió un error por favor inténtalo de nuevo.',
                type: 'error',
                timer: 5000,
                showConfirmButton: false
            });
            }; // Fin del error del Swal. */
        }, error => {
            console.log("Ups, hubo un error obteniendo el usuario para cambiar!");
        });// FIn del user Service para obtener el id a cambiar!.
        
    }

    closeAllRooms(status: number) {
        if (this.arrayCheckSel.length == 0) {
            this.title_toModal = "Advertencia";
            this.body_toModal = "Debe seleccionar al menos 1 conversación para cerrar";
            $('#controlRoom2').modal('toggle',{backdrop: "false"});
            $('#controlRoom2').appendTo("body");
        } else {
            let user = '';
            if(this._sharedService.activateBlockSupervisor().agent_id) {
                user = this._sharedService.activateBlockSupervisor().agent_id;
            } else {
                user = this.user_id;
            }

            var data = {
                auth_token: this._sharedService.getCookie("auth_token"),
                user_id: user,
                roomsSelect: this.arrayCheckSel,
                supervisor_id: this.user_id,
                status_id : status
            }

            this.spinner.show();
            this.userService.changeRoomStatusAll(data).subscribe(
            response => {
                if (response.code_status === 200) { 
                    if (response.message === 'Ocurrió un error') {
                        this.title_toModal = "Advertencia";
                        this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                        $('#controlRoom2').modal('toggle', {backdrop: "false"});
                        $('#controlRoom2').appendTo("body");
                        this.spinner.hide();
                    } else {
                        this.arrayCheckSel = [];
                        let data = this.getDataCookie();
                        this.letData = data;
                        this.getInitialData(data);
                        this.spinner.hide();
                    }
                }else {
                    this.title_toModal = "Advertencia";
                    this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
                    $('#controlRoom2').modal('toggle', {backdrop: "false"});
                    $('#controlRoom2').appendTo("body");
                    this.spinner.hide();
                    this.logger.log(response);
                }
            },
            error => { 
                this.logger.log(<any>error);
            } 
            ); 
        }
    }

    refeshRooms(){
        let agentId=null;
        if(this.active_control && this._sharedService.activateBlockSupervisor().agent_id){
            agentId = this._sharedService.activateBlockSupervisor().agent_id;
            console.log("Entro como admin a refeshRooms. Id del asesor",agentId);
            console.log("Entro como admin a refeshRooms. Id del administrador",this.user_id);
        }else{
            agentId = this.user_id;
            console.log("Entro como asesor a refeshRooms. Id del agente",this.user_id);
        }

        if(agentId){
            var data = {
                auth_token: this._sharedService.getCookie("auth_token"),
                user_id: agentId,
            }
            
            this.userService.refreshRooms(data).subscribe(
                response => {
                    let data_cookie = this.getDataCookie();
                    this.getInitialData(data_cookie);
                },
                error => { 
                    this.logger.log(<any>error);
                } 
            );
        }
        else{
            console.log("Error al refrescar, no se tiene un user id válido",this.user_id);
        }
    } 

    changeTab(tab: string) {
        this.activeTab = tab;
    }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/chat/list/list.component.ts